import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ClockIcon, ZapIcon, LeafIcon, SparklesIcon, HeartPulseIcon, MoonIcon, ShieldIcon } from 'lucide-react';
import type { Article } from '../data/articles';
const iconMap: Record<string, ComponentType<{
  className?: string;
}>> = {
  ZapIcon,
  LeafIcon,
  SparklesIcon,
  HeartPulseIcon,
  MoonIcon,
  ShieldIcon
};
interface ArticleCardProps {
  article: Article;
  className?: string;
  index?: number;
}
export function ArticleCard({
  article,
  className = '',
  index = 0
}: ArticleCardProps) {
  const Icon = iconMap[article.iconName] || SparklesIcon;
  return <Link to={`/artikel/${article.slug}`} className={`group flex flex-col bg-white rounded-softer shadow-vita-card overflow-hidden hover:shadow-vita-hover transition-all duration-300 transform hover:-translate-y-1 border border-vita-border/50 ${className}`} data-id="element-21">
      {/* Image Placeholder Area */}
      <div className={`h-48 w-full bg-gradient-to-br ${article.bgGradient} flex items-center justify-center relative overflow-hidden`} data-id="element-22">
        <div className="absolute inset-0 opacity-20 mix-blend-multiply" data-id="element-23">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-24">
            <defs data-id="element-25">
              <pattern id={`card-pattern-${article.slug}`} x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-26">
                <circle cx="20" cy="20" r="2" fill="currentColor" className="text-vita-green-sage" data-id="element-27" />
              </pattern>
            </defs>
            <rect x="0" y="0" width="100%" height="100%" fill={`url(#card-pattern-${article.slug})`} data-id="element-28" />
          </svg>
        </div>
        <div className="relative z-10 transform group-hover:scale-110 transition-transform duration-500" data-id="element-29">
          <Icon className="w-12 h-12 opacity-50" data-id="element-30" />
        </div>
      </div>

      {/* Content Area */}
      <div className="p-6 md:p-8 flex flex-col flex-grow" data-id="element-31">
        <div className="mb-4" data-id="element-32">
          <span className={`inline-block px-3 py-1 text-xs font-medium ${article.categoryText} ${article.categoryBg} rounded-full`} data-id="element-33">
            {article.category}
          </span>
        </div>

        <h3 className="font-heading text-xl font-bold text-vita-text mb-3 group-hover:text-vita-green-deep transition-colors duration-200 line-clamp-2" data-id="element-34">
          {article.title}
        </h3>

        <p className="text-vita-text-muted mb-6 flex-grow line-clamp-3" data-id="element-35">
          {article.preview}
        </p>

        <div className="flex items-center justify-between mt-auto pt-4 border-t border-vita-border/50" data-id="element-36">
          <div className="flex items-center text-sm text-vita-text-light" data-id="element-37">
            <ClockIcon className="w-4 h-4 mr-1.5" data-id="element-38" />
            {article.readTime}
          </div>
          <span className="text-sm font-medium text-vita-green-deep group-hover:text-vita-orange transition-colors duration-200 flex items-center" data-id="element-39">
            Weiterlesen
            <svg className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-40">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-41" />
            </svg>
          </span>
        </div>
      </div>
    </Link>;
}